import React, { useEffect, useState } from "react";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";
import { useNavigate } from "react-router-dom";

interface InteractionsStaleTableState {
  data: any;
}

export const InteractionsStaleTable = ({ data }: InteractionsStaleTableState): React.JSX.Element | null => {
  const [tableData, setTableData] = useState<any[]>();
  let navigate = useNavigate();

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name", clickable: true },
    { label: "Case Manager", key: "creator_name", width: "200px" },
    { label: "Most Recent Interaction", key: "most_recent_date_only", width: "200px" },
  ];

  useEffect(() => {
    if (data) {
      const { notes } = data;
      setTableData(notes?.stale_cases || []);
    } else {
      setTableData([]);
    }
  }, [data]);

  const onClickRow = (caseId: string) => {
    navigate(`/my-cases/${caseId}?key=notes`);
  };

  return tableData ? (
    <DataTable
      tableHeadings={tableHeaders}
      tableData={tableData}
      title={"Cases with No Interactions in Past Week"}
      onClickRow={(e: any) => onClickRow(e)}
    />
  ) : (
    loadingCard()
  );
};
